import { IHighlightsFolder, ISegment } from '@/types/highlight.interface'
import { formatTime } from '@/utils/formatTime'

export const getHighlightsDuration = (segments: ISegment[]) => {
	if (!segments.length) return undefined

	let totalSeconds = 0

	segments.forEach(segment => {
		totalSeconds += Math.floor(segment.end) - Math.floor(segment.start)
	})

	return formatTime(totalSeconds)
}

export const getHighlightSummary = (folders: IHighlightsFolder[]) => {
	const segments = folders.flatMap(folder => folder.segments)

	return {
		totalHighlightsAmount: segments.length ? segments : undefined,
		totalTimeHighlights: getHighlightsDuration(segments),
		allFolderIds: folders.map(folder => folder.id)
	}
}
